import React, { PureComponent } from 'react';
import b from 'b_';

import './event-item-vertical.stub.css';

import Rect from '@components/rect';

const class_ = b.with('event-item-vertical-stub');

export default class EventItemVerticalStub extends PureComponent {
    public render() {
        return (
            <div className={class_()}>
                <Rect
                    className={class_('image')}
                    width={'100%'}
                    height={150}
                />
                <div className={class_('info')}>
                    <Rect
                        className={class_('date-interval')}
                        width={100}
                        height={30}
                        type="black"
                    />
                    <Rect
                        className={class_('title')}
                        width={'100%'}
                        height={50}
                        type="black"
                    />
                    <Rect
                        className={class_('description')}
                        width={'100%'}
                        height={60}
                    />
                    <div className={class_('bottom')}>
                        <Rect
                            className={class_('city')}
                            width={80}
                            height={20}
                        />
                        <Rect
                            className={class_('materials')}
                            width={80}
                            height={20}
                        />
                    </div>
                </div>
            </div>
        );
    }
}
